/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_Content_DescInputs */

const en_directory_submit_workspace_aside_content_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Content_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the form, AI Autofill, or your agent.`)
};

const zh_directory_submit_workspace_aside_content_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Content_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用表单、AI 自动填写或你的 Agent。`)
};

/**
* | output |
* | --- |
* | "Use the form, AI Autofill, or your agent." |
*
* @param {Directory_Submit_Workspace_Aside_Content_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_content_desc = /** @type {((inputs?: Directory_Submit_Workspace_Aside_Content_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_Content_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_content_desc(inputs)
	return zh_directory_submit_workspace_aside_content_desc(inputs)
});
export { directory_submit_workspace_aside_content_desc as "directory.submit.workspace.aside.content_desc" }